<template>
  <div class="work-step" :class="{ 'flow-step--readonly': viewOnly }">
    <div class="work-step__cards">
      <article class="work-mobile-card work-mobile-card--vendor">
        <header class="work-mobile-card__header">
          <div class="work-mobile-card__icon work-mobile-card__icon--vendor">
            <i class="fas fa-tools" aria-hidden="true" />
          </div>
          <div class="work-mobile-card__titles">
            <h3 class="work-mobile-card__title">{{ vendorCardTitle }}</h3>
            <p class="work-mobile-card__subtitle">External goods</p>
          </div>
          <button
            v-if="!viewOnly"
            type="button"
            class="work-mobile-card__link"
            @click="handleVendorAddExternalGoods"
          >
            + Add
          </button>
        </header>

        <div class="work-mobile-card__stats">
          <div class="work-stat-row">
            <span>Item count</span>
            <span>{{ externalGoodsItemCount }}</span>
          </div>
          <div class="work-stat-row work-stat-row--total">
            <span>Total amount</span>
            <span>{{ formatWorkAmount(externalGoodsTotalAmount) }}</span>
          </div>
        </div>

        <div class="work-mobile-card__details">
          <div class="chalan-list sr-flow-table-wrap">
            <el-table
              v-if="externalGoodsList.length > 0"
              class="sr-flow-el-table sr-flow-work-table"
              :data="externalGoodsList"
              style="width: 100%"
            >
              <el-table-column type="index" label="#" width="48" />
              <el-table-column
                label="Name"
                prop="name"
                min-width="120"
                show-overflow-tooltip
              />
              
                <template slot-scope="scope">
                  {{ scope.row.type | modifyType }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </article>

      <article class="work-mobile-card work-mobile-card--rajput">
        <header class="work-mobile-card__header">
          <div class="work-mobile-card__icon work-mobile-card__icon--rajput">
            <i class="fas fa-box" aria-hidden="true" />
          </div>
          <div class="work-mobile-card__titles">
            <h3 class="work-mobile-card__title">{{ branchDisplayName }}</h3>
            <p class="work-mobile-card__subtitle">Chalan</p>
          </div>
          <button
            v-if="!viewOnly"
            type="button"
            class="work-mobile-card__refresh"
            title="Refresh chalans"
            @click="refreshChalans"
          >
            <i class="fas fa-sync-alt" aria-hidden="true" />
          </button>
        </header>

        <div class="work-mobile-card__stats">
          <div class="work-stat-row">
            <span>Inward chalan</span>
            <span>{{ formatChalanSummary(inwardChalanSummary) }}</span>
          </div>
          <div class="work-stat-row">
            <span>Outward chalan</span>
            <span>{{ formatChalanSummary(outwardChalanSummary) }}</span>
          </div>
          <div class="work-stat-row work-stat-row--total">
            <span>Amount till date</span>
            <span>{{ formatWorkAmount(chalanAmountTillDate) }}</span>
          </div>
        </div>
      </article>
    </div>

    <template v-if="!viewOnly">
    <!-- chalan dialog -->
    <el-dialog :visible.sync="showChalan" title="Add Chalan">
      <div class="row">
        <div class="col-md-6">
          <base-input label="Inward Chalan?">
            <el-radio
              v-model="serviceRequestChalan.isInward"
              :label="true"
              @change="fetchServiceRequestProducts"
            >
              Yes
            </el-radio>
            <el-radio v-model="serviceRequestChalan.isInward" :label="false">
              No
            </el-radio>
          </base-input>
        </div>
        <div class="col-md-6">
          <div style="float: right; margin-top: 20px">
            <base-button
              type="primary"
              size="sm"
              @click="handleChalanProductAdd()"
              >Add New</base-button
            >
          </div>
        </div>
      </div>
      <el-table :data="serviceRequestChalan.chalanItems">
        <el-table-column label="Product Name">
          <template slot-scope="scope">
            <base-input>
              <el-autocomplete
                v-uppercase
                ref="searchProduct"
                v-model="scope.row.name"
                :fetch-suggestions="suggestProducts"
                :trigger-on-focus="false"
                popper-class="product-search product-search--dialog"
                placeholder="Type..."
                tabindex="4"
                value-key="name"
                @focus="setCurrentRow(scope.row)"
                @select="handleProductSelect"
              >
                <template slot-scope="{ item }">
                  <div class="value">{{ item.name }}</div>
                </template>
              </el-autocomplete>
            </base-input>
          </template>
        </el-table-column>
        <el-table-column label="Qty." min-width="40">
          <template slot-scope="scope">
            <base-input v-model="scope.row.quantity" />
          </template>
        </el-table-column>
        <el-table-column label="Actions" min-width="40">
          <template slot-scope="scope">
            <el-button
              style="margin-bottom: 20px"
              size="mini"
              type="danger"
              @click="handleChalanProductDelete(scope.$index)"
            >
              <i class="el-icon-delete" />
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showChalan = false">Cancel</el-button>
        <el-button type="primary" @click="addChalan()"> Confirm </el-button>
      </span>
    </el-dialog>
    <!-- external goods dialog -->
    <el-dialog
      :visible.sync="openGoodsDialog"
      title="Add External Goods.."
      width="60%"
    >
      <div class="row" style="margin-bottom: 10px">
        <div class="col-md-6">
          <base-button type="primary" size="sm" @click="handleExternalGoodAdd()"
            >Add New</base-button
          >
        </div>
      </div>
      <el-table :data="externalGoodsMeta">
        <el-table-column label="Name" min-width="200">
          <template slot-scope="scope">
            <div class="work-external-product-field">
              <base-input>
                <input
                  v-model="scope.row.name"
                  type="text"
                  class="form-control"
                  placeholder="Search or add product…"
                  autocomplete="off"
                  @focus="onExternalProductFieldFocus(scope.row, scope.$index)"
                  @blur="onExternalProductFieldBlur"
                  @input="onExternalProductFieldInput(scope.row, scope.$index)"
                />
              </base-input>
              <ul
                v-if="
                  externalGoodsActiveRowIndex === scope.$index &&
                    externalGoodsSearchPanelOpen &&
                    externalGoodsSearchResults.length
                "
                class="work-external-product-results"
              >
                <li
                  v-for="item in externalGoodsSearchResults"
                  :key="item.productId"
                  class="work-external-product-results__row"
                >
                  <button
                    type="button"
                    class="work-external-product-results__pick"
                    @mousedown.prevent="
                      pickExternalProduct(item, scope.row, scope.$index)
                    "
                  >
                    {{ item.name }}
                  </button>
                </li>
              </ul>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Qty.">
          <template slot-scope="scope">
            <base-input v-model="scope.row.quantity" type="number" />
          </template>
        </el-table-column>
        <el-table-column label="Total">
          <template slot-scope="scope">
            <base-input v-model="scope.row.total" type="number" />
          </template>
        </el-table-column>
        <el-table-column label="Type">
          <template slot-scope="scope">
            <el-radio v-model="scope.row.type" label="external"
              >External</el-radio
            >
            <el-radio v-model="scope.row.type" label="internal"
              >Internal</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column min-width="50">
          <template slot-scope="scope">
            <el-button
              style="margin-bottom: 20px"
              size="mini"
              type="danger"
              @click="handleExternalGoodDelete(scope.$index)"
            >
              <i class="el-icon-delete" />
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div
        v-if="externalGoodsList.length > 0"
        class="work-external-goods-dialog-saved sr-flow-table-wrap"
      >
        <el-table
          class="sr-flow-el-table sr-flow-work-table"
          :data="externalGoodsList"
          style="width: 100%"
        >
          <el-table-column type="index" label="#" width="48" />
          <el-table-column
            label="Name"
            prop="name"
            min-width="120"
            show-overflow-tooltip
          />
          <el-table-column label="Quantity" prop="quantity" min-width="80" />
          <el-table-column label="Total" prop="total" min-width="80" />
          <el-table-column label="Type" prop="type" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.type | modifyType }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="clearExternalGoods()">Cancel</el-button>
        <el-button type="primary" @click="addExternalGoods()">
          Confirm
        </el-button>
      </span></el-dialog
    >
    </template>
  </div>
</template>

<script>
import dateFns from "date-fns";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import {
  Dialog,
  Button,
  Table,
  TableColumn,
  Autocomplete,
  Select,
  Option,
  Input,
  Radio,
  Tag
} from "element-ui";
import branchDetailsMixin from "@/mixins/branchDetailsMixin";
import { vendorDisplayName } from "@/utils/serviceRequestFlowHelpers";
import serviceRequestFlowViewOnlyMixin from "@/mixins/serviceRequestFlowViewOnlyMixin";

export default {
  mixins: [branchDetailsMixin, serviceRequestFlowViewOnlyMixin],
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Autocomplete.name]: Autocomplete,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Radio.name]: Radio,
    [Tag.name]: Tag
  },
  filters: {
    dateFormat(value) {
      return dateFns.format(new Date(value), "DD MMM YYYY");
    },
    convertType(value) {
      if (value === true) {
        return "Inward Chalan";
      } else {
        return "Outward Chalan";
      }
    },
    modifyType(value) {
      const modified = value
        .split(" ")
        .map(i => i.charAt(0).toUpperCase() + i.slice(1))
        .join(" ");
      return modified;
    },
    currency(value) {
      const amount = parseFloat(value) || 0;
      const a = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
      return a.replace(".00", "");
    }
  },
  data() {
    return {
      amount: 0,
      showChalan: false,
      currentRow: {},
      externalGoodsCurrentRow: null,
      externalGoodsActiveRowIndex: null,
      externalGoodsSearchQuery: "",
      externalGoodsSearchResults: [],
      externalGoodsSearchPanelOpen: false,
      externalGoodsSearchTimer: null,
      externalGoodsSearchBlurTimer: null,
      serviceRequestProducts: [],
      openGoodsDialog: false,
      activeName: "first",
      externalGoodsMeta: [
        {
          name: "",
          quantity: "",
          total: "",
          type: "external"
        }
      ]
    };
  },

  computed: {
    ...mapState("serviceRequestChalan", [
      "serviceRequestChalan",
      "serviceRequestChalansList"
    ]),
    ...mapState("serviceRequest", ["serviceRequest"]),
    ...mapState("serviceRequestLabor", ["serviceRequestLabors"]),
    ...mapGetters({
      statusList: "status/getStatusList",
      serviceRequestQuotations:
        "serviceRequestQuotation/getServiceRequestQuotationList"
    }),
    vendorName() {
      return vendorDisplayName(this.serviceRequest);
    },
    vendorCardTitle() {
      const vendor = this.serviceRequest && this.serviceRequest.vendor;
      if (!vendor || typeof vendor !== "object") return this.vendorName;
      const firm = (vendor.firmName || vendor.firm_name || "").trim();
      if (firm) return firm;
      return this.vendorName;
    },
    externalGoodsList() {
      const meta =
        this.serviceRequest && this.serviceRequest.externalGoodsMeta;
      if (!Array.isArray(meta)) return [];
      return meta.filter(
        row =>
          row &&
          ((row.name && String(row.name).trim()) ||
            row.quantity != null ||
            (row.total != null && parseFloat(row.total) > 0))
      );
    },
    externalGoodsItemCount() {
      return this.externalGoodsList.length;
    },
    externalGoodsTotalAmount() {
      const fromRequest = parseFloat(this.serviceRequest.externalGoodsTotal);
      if (!isNaN(fromRequest) && fromRequest > 0) {
        return fromRequest;
      }
      return this.externalGoodsList.reduce(
        (sum, row) => sum + (parseFloat(row.total) || 0),
        0
      );
    },
    inwardChalanSummary() {
      return this.summarizeChalansByDirection(true);
    },
    outwardChalanSummary() {
      return this.summarizeChalansByDirection(false);
    },
    chalanAmountTillDate() {
      const list = this.serviceRequestChalansList || [];
      return list.reduce(
        (sum, chalan) => sum + this.chalanRowAmount(chalan),
        0
      );
    }
  },

  mounted() {
    this.loadBranchDetails();
    this.getServiceRequest(this.$route.params.id);
    this.getServiceRequestChalans(this.$route.params.id);
    if ((this.serviceRequest.externalGoodsMeta = {})) {
      this.serviceRequest.externalGoodsMeta = [
        {
          name: "",
          quantity: null,
          total: null,
          type: "external"
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      getProducts: "product/getProducts",
      getProduct: "product/getProduct",
      getPaymentModes: "paymentMode/getPaymentModes",
      saveServiceRequestChalan: "serviceRequestChalan/saveServiceRequestChalan",
      getServiceRequestChalans: "serviceRequestChalan/getServiceRequestChalans",
      fetchServiceRequest: "serviceRequest/fetchServiceRequest",
      updateServiceRequestChalan:
        "serviceRequestChalan/updateServiceRequestChalanData",
      addExternalGoodsData: "serviceRequest/addExternalGoodsData",
      getServiceRequest: "serviceRequest/fetchServiceRequest"
    }),

    ...mapMutations({
      resetServiceRequestChalan:
        "serviceRequestChalan/resetServiceRequestChalan"
    }),

    chalanRowAmount(chalan) {
      if (!chalan || typeof chalan !== "object") return 0;
      const total = parseFloat(chalan.total);
      if (!isNaN(total) && total) return total;
      const grandTotal = parseFloat(chalan.grandTotal);
      if (!isNaN(grandTotal) && grandTotal) return grandTotal;
      const items = chalan.chalanItems;
      if (!Array.isArray(items)) return 0;
      return items.reduce(
        (sum, item) =>
          sum +
          (parseFloat(item.amount) ||
            parseFloat(item.total) ||
            0),
        0
      );
    },
    summarizeChalansByDirection(isInward) {
      const list = (this.serviceRequestChalansList || []).filter(
        chalan => chalan.isInward === isInward
      );
      return {
        count: list.length,
        amount: list.reduce(
          (sum, chalan) => sum + this.chalanRowAmount(chalan),
          0
        )
      };
    },
    formatWorkAmount(amount) {
      const value = parseFloat(amount) || 0;
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0
      }).format(value);
    },
    formatChalanSummary(summary) {
      const s = summary || { amount: 0, count: 0 };
      return `${this.formatWorkAmount(s.amount)} (${s.count})`;
    },
    refreshChalans() {
      this.getServiceRequestChalans(this.$route.params.id);
    },
    handleVendorAddExternalGoods() {
      if (this.viewOnly) return;
      this.openExternalGoodsDialog();
    },

    /* --------- chalans related functions ----------- */
    openChalanDialog() {
      if (this.viewOnly) return;
      // checking if sale invoice is generated and if status is completed
      if (
        this.serviceRequest.saleId ||
        this.serviceRequest.status.code === "completed"
      ) {
        this.$notify({
          message:
            "You Can Not Add Chalan After Generating Invoice or with completed status!",
          type: "danger",
          title: "Failure"
        });
      } else {
        this.resetServiceRequestChalan();
        this.showChalan = true;
      }
    },
    addChalan() {
      if (this.viewOnly) return;
      const status = this.statusList.filter(i => i.code === "pending");
      this.serviceRequestChalan.statusId = status[0].statusId;
      this.serviceRequestChalan.createdBy = this.serviceRequest.vendorId;
      this.saveServiceRequestChalan(this.$route.params.id)
        .then(() => {
          this.getServiceRequestChalans(this.$route.params.id);
          this.showChalan = false;
          this.$notify({
            message: "Chalan Added Succesfully!",
            type: "success",
            title: "Success"
          });
        })
        .catch(() => {
          this.$notify({
            message: "Try Again!",
            type: "danger",
            title: "Failure"
          });
        });
    },
    async suggestProducts(query, cb) {
      const q = (query || "").trim();
      if (!q) {
        cb([]);
        return;
      }
      try {
        if (this.serviceRequestChalan.isInward === true) {
          const list = (this.serviceRequestProducts || []).filter(p =>
            String(p.name || "")
              .toLowerCase()
              .includes(q.toLowerCase())
          );
          cb(list);
        } else {
          const result = await this.getProducts({ searchKeyword: q });
          cb((result && result.rows) || []);
        }
      } catch (e) {
        cb([]);
      }
    },
    onExternalProductFieldFocus(row, index) {
      if (this.externalGoodsSearchBlurTimer) {
        clearTimeout(this.externalGoodsSearchBlurTimer);
        this.externalGoodsSearchBlurTimer = null;
      }
      this.externalGoodsCurrentRow = row;
      this.externalGoodsActiveRowIndex = index;
      this.externalGoodsSearchPanelOpen = true;
      const q = (row.name || "").trim();
      this.externalGoodsSearchQuery = q;
      this.fetchExternalProductSuggestions(q);
    },
    onExternalProductFieldBlur() {
      this.externalGoodsSearchBlurTimer = setTimeout(() => {
        this.externalGoodsSearchPanelOpen = false;
      }, 200);
    },
    onExternalProductFieldInput(row, index) {
      this.externalGoodsCurrentRow = row;
      this.externalGoodsActiveRowIndex = index;
      this.externalGoodsSearchPanelOpen = true;
      const q = (row.name || "").trim();
      this.externalGoodsSearchQuery = q;
      if (this.externalGoodsSearchTimer) {
        clearTimeout(this.externalGoodsSearchTimer);
      }
      this.externalGoodsSearchTimer = setTimeout(() => {
        this.fetchExternalProductSuggestions(q);
      }, 300);
    },
    async fetchExternalProductSuggestions(q) {
      const query = (q || "").trim();
      const requestQuery =
        query.length >= 1
          ? { searchKeyword: query, page: 1, perPage: 50 }
          : { page: 1, perPage: 50 };
      try {
        const result = await this.getProducts(requestQuery);
        if (this.externalGoodsSearchQuery.trim() === query) {
          this.externalGoodsSearchResults = (result && result.rows) || [];
        }
      } catch (e) {
        if (this.externalGoodsSearchQuery.trim() === query) {
          this.externalGoodsSearchResults = [];
        }
      }
    },
    pickExternalProduct(item, row, index) {
      if (!row || !item) return;
      row.name = item.name;
      row.productId = item.productId;
      if (!row.quantity) {
        row.quantity = 1;
      }
      const unitPrice = parseFloat(
        item.sellingPrice != null ? item.sellingPrice : item.price
      );
      if (!isNaN(unitPrice) && (row.total == null || row.total === "")) {
        const qty = parseInt(row.quantity, 10) || 1;
        row.total = unitPrice * qty;
      }
      this.externalGoodsSearchQuery = row.name || "";
      this.externalGoodsSearchPanelOpen = false;
      this.externalGoodsSearchResults = [];
      this.externalGoodsActiveRowIndex = index;
    },
    resetExternalGoodsSearch() {
      this.externalGoodsSearchQuery = "";
      this.externalGoodsSearchResults = [];
      this.externalGoodsSearchPanelOpen = false;
      this.externalGoodsActiveRowIndex = null;
      if (this.externalGoodsSearchTimer) {
        clearTimeout(this.externalGoodsSearchTimer);
        this.externalGoodsSearchTimer = null;
      }
      if (this.externalGoodsSearchBlurTimer) {
        clearTimeout(this.externalGoodsSearchBlurTimer);
        this.externalGoodsSearchBlurTimer = null;
      }
    },
    handleChalanProductAdd() {
      this.serviceRequestChalan.chalanItems.push({
        name: "",
        quantity: 1
      });
    },
    handleChalanProductDelete(index) {
      this.serviceRequestChalan.chalanItems.splice(index, 1);
    },
    handleProductSelect(item) {
      this.currentRow.productId = item.productId;
      this.currentRow.taxRate = item.tax.rate;
    },
    setCurrentRow(row) {
      this.currentRow = row;
    },
    fetchServiceRequestProducts() {
      if (this.serviceRequestChalan.isInward === true) {
        let acceptedChalanProducts = [];
        this.serviceRequestChalansList.forEach(i => {
          if (i.status.code === "accepted") {
            acceptedChalanProducts.push(...i.chalanItems);
          }
        });
        acceptedChalanProducts.forEach(async i => {
          const product = await this.getProduct(i.productId);
          this.serviceRequestProducts.push({
            productId: i.productId,
            quantity: i.quantity,
            name: product.name,
            tax: product.tax
          });
        });
        if (acceptedChalanProducts.length <= 0) {
          this.$notify({
            message: "Cannot Inward Chalan!",
            type: "danger",
            title: "Failure"
          });
        }
      }
    },
    updateChalan(data) {
      if (this.viewOnly) return;
      const newStatus = this.statusList.find(i => i.code === "accepted");
      this.updateServiceRequestChalan({
        statusId: newStatus.statusId,
        serviceRequestChalanId: data.serviceRequestChalanId,
        serviceRequestId: this.$route.params.id
      }).then(() => {
        this.getServiceRequestChalans(this.$route.params.id);
        this.$notify({
          message: "Chalan Updated Succesfully!",
          type: "success",
          title: "Success"
        });
      });
    },

    /* --------- external goods related functions ----------- */

    openExternalGoodsDialog() {
      if (this.viewOnly) return;
      // checking if vendor invoice is generated and if status is completed
      if (
        this.serviceRequest.vendorInvoice ||
        this.serviceRequest.status.code === "completed"
      ) {
        this.$notify({
          message:
            "You Can Not Add External Good After Generating Invoice or with completed status!",
          type: "danger",
          title: "Failure"
        });
      } else {
        this.openGoodsDialog = true;
        this.resetExternalGoods();
      }
    },
    resetExternalGoods() {
      this.resetExternalGoodsSearch();
      this.externalGoodsMeta = [
        {
          name: "",
          quantity: null,
          total: null,
          type: "external"
        }
      ];
    },

    handleExternalGoodDelete(index) {
      this.externalGoodsMeta.splice(index, 1);
    },
    handleExternalGoodAdd() {
      this.externalGoodsMeta.push({
        name: "",
        quantity: null,
        total: null,
        type: "external"
      });
    },
    addExternalGoods() {
      if (this.viewOnly) return;
      const newRows = [];
      this.externalGoodsMeta.forEach(i => {
        if (i.name && i.quantity && i.total > 0) {
          newRows.push({
            name: i.name,
            quantity: parseInt(i.quantity, 10),
            total: parseFloat(i.total),
            type: i.type
          });
        }
      });
      const existingRows = this.externalGoodsList.map(row => ({
        name: row.name,
        quantity: parseInt(row.quantity, 10),
        total: parseFloat(row.total),
        type: row.type
      }));
      const list = [...existingRows, ...newRows];
      if (!list.length) {
        this.$notify({
          message: "Add at least one item with name, quantity, and total.",
          type: "warning",
          title: "Validation"
        });
        return;
      }
      this.addExternalGoodsData({
        externalGoodsMeta: list
      })
        .then(() => {
          this.resetExternalGoods();
          this.$notify({
            message: "External Good/s Added Successfully!",
            type: "success",
            title: "Success"
          });
        })
        .catch(() => {
          this.$notify({
            message: "Try Again!",
            type: "danger",
            title: "Failure"
          });
        });
    },
    updateExternalGood(goods) {
      if (this.viewOnly) return;
      // checking if vendor invoice is generated and if status is completed
      if (
        this.serviceRequest.vendorInvoice ||
        this.serviceRequest.status.code === "completed"
      ) {
        this.$notify({
          message:
            "You Can Not Add External Good After Generating Invoice or with completed status!",
          type: "danger",
          title: "Failure"
        });
      } else {
        this.externalGoodsMeta = [];
        for (const i of goods) {
          this.externalGoodsMeta.push({
            name: i.name,
            quantity: i.quantity,
            total: i.total,
            type: i.type
          });
        }
        this.openGoodsDialog = true;
      }
    },
    clearExternalGoods() {
      this.openGoodsDialog = false;
      this.resetExternalGoodsSearch();
      this.externalGoodsMeta = [];
      this.externalGoodsMeta.push({
        name: "",
        quantity: null,
        total: null,
        type: "external"
      });
    }
  }
};
</script>

<style>
.work-step__cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.work-mobile-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.work-mobile-card--vendor {
  border-color: #93c5fd;
  box-shadow: 0 0 0 1px #bfdbfe;
}
.work-mobile-card--rajput {
  border-color: #fdba74;
  box-shadow: 0 0 0 1px #fed7aa;
}
.work-mobile-card__header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 14px 10px;
}
.work-mobile-card__icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.work-mobile-card__icon--vendor {
  background: #dbeafe;
  color: #2563eb;
}
.work-mobile-card__icon--rajput {
  background: #ffedd5;
  color: #ea580c;
}
.work-mobile-card__titles {
  flex: 1;
  min-width: 0;
}
.work-mobile-card__title {
  margin: 0 0 2px;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
  word-break: break-word;
}
.work-mobile-card__subtitle {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}
.work-mobile-card__link {
  flex-shrink: 0;
  border: none;
  background: transparent;
  padding: 4px 0;
  font-size: 13px;
  font-weight: 600;
  color: #2563eb;
  cursor: pointer;
  white-space: nowrap;
}
.work-mobile-card__link:hover {
  text-decoration: underline;
}
.work-mobile-card__refresh {
  flex-shrink: 0;
  border: none;
  background: transparent;
  padding: 8px;
  font-size: 16px;
  color: #6b7280;
  cursor: pointer;
  line-height: 1;
}
.work-mobile-card__refresh:hover {
  color: #2563eb;
}
.work-mobile-card__stats {
  margin: 0 14px 14px;
  padding: 4px 12px;
  background: #f3f4f6;
  border-radius: 8px;
}
.work-stat-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 14px;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
}
.work-stat-row:last-child {
  border-bottom: none;
}
.work-stat-row span:last-child {
  font-weight: 600;
  color: #111827;
}
.work-stat-row--total span:last-child {
  font-weight: 700;
  font-size: 15px;
}
.work-mobile-card__details {
  padding: 0 10px 12px;
  border-top: 1px solid #f3f4f6;
}
.chalan-list {
  margin-top: 8px;
  margin-bottom: 8px;
}
.sr-flow-table-wrap {
  max-width: 100%;
}
.chalan-list .sr-flow-work-table {
  width: 100%;
  min-width: 0;
}
.chalan-list .sr-flow-work-table th > .cell {
  white-space: nowrap;
  word-break: keep-all;
  line-height: 1.25;
}
.chalan-list .sr-flow-work-table td > .cell {
  white-space: normal;
  word-break: break-word;
  line-height: 1.45;
}
.flow-empty-hint {
  margin: 8px 0 0;
  font-size: 13px;
  color: #6b7280;
}
.chalan-details {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
}
.chalan-item {
  display: flex;
}
.chalan-item label {
  font-weight: 600;
  font-size: 13px;
  margin-right: 4px;
}
.card .advance-amount-card {
  border: 0 1px;
}
.advance-amount-card .advance-body {
  margin: 10px;
}
.advance-footer {
  margin-left: 88%;
}
.approx-product-remove-item {
  margin-left: 60px;
  margin-top: -26px;
  font-size: 25px;
  cursor: pointer;
}
.product-search {
  width: 267px !important;
}
.product-search--dialog {
  z-index: 5000 !important;
}
.work-external-product-field {
  position: relative;
}
.work-external-product-results {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 5100;
  max-height: 280px;
  overflow-y: auto;
  margin: 4px 0 0;
  padding: 6px 0;
  list-style: none;
  background: #fff;
  border: 1px solid #c7d2fe;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.work-external-product-results__row {
  border-bottom: 1px solid #f3f4f6;
}
.work-external-product-results__row:last-child {
  border-bottom: none;
}
.work-external-product-results__pick {
  display: block;
  width: 100%;
  padding: 12px 14px;
  border: 0;
  background: transparent;
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
  color: #111827;
  cursor: pointer;
}
.work-external-product-results__pick:hover {
  background: #f3f4f6;
}
.work-step .el-dialog__body .el-table__body-wrapper {
  overflow: visible;
}
.work-step .el-dialog__body .el-table .cell {
  overflow: visible;
}
.pending-status {
  background-color: #e72626;
  border-color: #e72626;
  color: #fff;
}
.dispatch-status {
  background-color: #f57316eb;
  border-color: #f57316eb;
  color: #fff;
}
</style>
